<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>Name</th>
        <th>
          <input
            type="text"
            class="form-control"
            id="search-text"
            aria-describedby="search-text"
            [(ngModel)]="searchText"
            placeholder="Search"
            autofocus
          />
        </th>
        <th>
          <button
            class="add"
            mat-raised-button
            color="basic"
            (click)="addNew()"
          >
            Add New
          </button>
        </th>
      </tr>
      <tr class="td" *ngFor="let emplyee of filterddata">
        <td>{{ emplyee.name }}</td>
        <td>{{ emplyee.Status }}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(emplyee)">
            Edit
          </button>
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>

  <form
    [formGroup]="groupForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'add'"
  >
    <div class="post">
      <div class="title">Create Employee</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput placeholder="Mr" maxlength="45" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Employee Type</mat-label>
            <mat-select
              formControlName="employee_type_id"
              matNativeControl
              required
            >
              <mat-option *ngFor="let cat of cats" [value]="cat.id">{{
                cat.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Category</mat-label>
            <mat-select
              formControlName="category_name"
              matNativeControl
              required
            >
              <mat-option *ngFor="let cat of cats" [value]="cat.id">{{
                cat.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Title</mat-label>
            <mat-select formControlName="title_name" matNativeControl required>
              <mat-option *ngFor="let title of titles" [value]="title.id">{{
                title.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
              <mat-label>Consultant Type</mat-label>
              <mat-select formControlName="consultant_type" matNativeControl required>
                <mat-option *ngFor="let cat of cats" [value]="country.id">{{country.name}}</mat-option>
              </mat-select>
            </mat-form-field>
         </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Specialization</mat-label>
            <mat-select
              formControlName="specialisation"
              matNativeControl
              required
            >
              <mat-option
                *ngFor="let special of specials"
                [value]="special.Spec_Id"
                >{{ special.Spec_Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select
              formControlName="department_code"
              matNativeControl
              required
            >
              <mat-option *ngFor="let dept of depts" [value]="dept.id">{{
                dept.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Registration No</mat-label>
            <input formControlName="registration_no" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 1</mat-label>
            <input formControlName="address1" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 2</mat-label>
            <input formControlName="address2" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>City</mat-label>
            <mat-select formControlName="city_id" matNativeControl required>
              <mat-option *ngFor="let city of cities" [value]="city.id">{{
                city.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="country_id" matNativeControl required>
              <mat-option
                *ngFor="let country of countries"
                [value]="country.id"
                >{{ country.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Mobile No</mat-label>
            <input formControlName="mobile" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input formControlName="email_no" matInput placeholder="" maxlength="30" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Designation</mat-label>
            <input formControlName="Designation" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Nationality</mat-label>
            <mat-select formControlName="Nationality" matNativeControl required>
              <!-- <mat-option *ngFor="let nat of nats" [value]="nat.id">{{nat.name}}</mat-option> -->
              <mat-option value="Nigerian">Nigerian</mat-option>
              <mat-option value="Others">Others</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Write Off Authorisation</mat-label>
            <mat-select
              formControlName="write_off_authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Concession Authorisation</mat-label>
            <mat-select
              formControlName="concession_authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Cancellation Authorisation</mat-label>
            <mat-select
              formControlName="cancellation_authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Admission Authorisation</mat-label>
            <mat-select
              formControlName="Admission_Authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Indent Authorisation</mat-label>
            <mat-select
              formControlName="Indent_Authorisation"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>PO Authorisation</mat-label>
            <mat-select formControlName="PO_AUTH" matNativeControl required>
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status" matNativeControl required>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Qualification</mat-label>
            <input formControlName="qualification" matInput placeholder="" />
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="groupForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'edit'"
  >
    <div class="post">
      <div class="title">Edit Employee</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput placeholder="Mr" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Employee Type</mat-label>
            <mat-select
              formControlName="employee_type_id"
              matNativeControl
              required
            >
              <mat-option *ngFor="let cat of cats" [value]="cat.id">{{
                cat.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Cartegory</mat-label>
            <mat-select
              formControlName="category_name"
              matNativeControl
              required
            >
              <mat-option *ngFor="let cat of cats" [value]="cat.id">{{
                cat.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Title</mat-label>
            <mat-select formControlName="title_name" matNativeControl required>
              <mat-option *ngFor="let title of titles" [value]="title.id">{{
                title.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
              <mat-label>Consultant Type</mat-label>
              <mat-select formControlName="consultant_type" matNativeControl required>
                <mat-option *ngFor="let cat of cats" [value]="country.id">{{country.name}}</mat-option>
              </mat-select>
            </mat-form-field>
         </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Specialization</mat-label>
            <mat-select
              formControlName="specialisation"
              matNativeControl
              required
            >
              <mat-option
                *ngFor="let special of specials"
                [value]="special.Spec_Id"
                >{{ special.Spec_Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select
              formControlName="department_code"
              matNativeControl
              required
            >
              <mat-option *ngFor="let dept of depts" [value]="dept.id">{{
                dept.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Registration No</mat-label>
            <input formControlName="registration_no" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 1</mat-label>
            <input formControlName="address1" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 2</mat-label>
            <input formControlName="address2" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>City</mat-label>
            <mat-select formControlName="city_id" matNativeControl required>
              <mat-option *ngFor="let city of cities" [value]="city.id">{{
                city.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="country_id" matNativeControl required>
              <mat-option
                *ngFor="let country of countries"
                [value]="country.id"
                >{{ country.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Mobile No</mat-label>
            <input formControlName="mobile" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input formControlName="email_no" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Designation</mat-label>
            <input formControlName="Designation" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Nationality</mat-label>
            <mat-select formControlName="Nationality" matNativeControl required>
              <!-- <mat-option *ngFor="let nat of nats" [value]="nat.id">{{nat.name}}</mat-option> -->
              <mat-option value="Nigerian">Nigerian</mat-option>
              <mat-option value="Others">Others</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Write Off Authorisation</mat-label>
            <mat-select
              formControlName="write_off_authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Concession Authorisation</mat-label>
            <mat-select
              formControlName="concession_authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Cancellation Authorisation</mat-label>
            <mat-select
              formControlName="cancellation_authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Admission Authorisation</mat-label>
            <mat-select
              formControlName="Admission_Authorised"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Indent Authorisation</mat-label>
            <mat-select
              formControlName="Indent_Authorisation"
              matNativeControl
              required
            >
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>PO Authorisation</mat-label>
            <mat-select formControlName="PO_AUTH" matNativeControl required>
              <mat-option value="N">No</mat-option>
              <mat-option value="Y">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status" matNativeControl required>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Qualification</mat-label>
            <input formControlName="qualification" matInput placeholder="" />
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
</div>
